<template>
  <div id="classRoomHome">
    <div class="home_top">
      <div class="home_left" :style="{ width: userIdentity == 2 ? '70%' : '50%' }">
        <div class="box_header">快捷入口</div>
        <div class="box_content dispalySpaceAround" v-if="userIdentity == 2">
          <div class="entrance_box" @click="goPage('LessonPreparationCenter')">
            <img src="../../assets/WDKC.png" alt="" />
            <p class="entrance_tips">备课中心</p>
          </div>
          <div class="entrance_box" @click="goPage('trainingForTeachers')">
            <img src="../../assets/SZPX.png" alt="" />
            <p class="entrance_tips">师资培训</p>
          </div>
          <div class="entrance_box" @click="goPage('teachingActivities')">
            <img src="../../assets/SQZP.png" alt="" />
            <p class="entrance_tips">教研活动</p>
          </div>
          <div class="entrance_box" @click="modelStatus = true">
            <img src="../../assets/ZYCZ.png" alt="" />
            <p class="entrance_tips">自由创作</p>
          </div>
        </div>
        <div class="box_content dispalySpaceAround" v-if="userIdentity == 1">
          <div class="entrance_box" @click="goPage('LessonPreparationCenter')">
            <img src="../../assets/WDKC.png" alt="" />
            <p class="entrance_tips">我的课程</p>
          </div>
          <div class="entrance_box" @click="goPage('myWorks')">
            <img src="../../assets/SZPX.png" alt="" />
            <p class="entrance_tips">我的作品</p>
          </div>
          <div class="entrance_box" @click="goPage('/work/list')">
            <img src="../../assets/SQZP.png" alt="" />
            <p class="entrance_tips">社区活动</p>
          </div>
          <div class="entrance_box" @click="modelStatus = true">
            <img src="../../assets/ZYCZ.png" alt="" />
            <p class="entrance_tips">自由创作</p>
          </div>
        </div>
      </div>
      <div class="home_right">
        <div class="box_header">今日课程</div>
        <div class="box_content">
          <div class="courseList displaybetween" v-show="courseList.length > 0" v-for="(item, index) in courseList"
            :key="index">
            <p>{{ item.courseName }}</p>
            <p>{{ item.openTime }}</p>
          </div>
          <p v-if="courseList.length == 0" class="listTips">暂无数据</p>
        </div>
      </div>
      <div class="home_right" style="width: calc(20% - 8px)" v-if="userIdentity == 1">
        <div class="box_header">信息栏</div>
        <div class="box_content displaywrap">
          <div class="data_box">
            <div class="data_text">
              作业提交次数
              <a-tooltip placement="top">
                <template slot="title">
                  <span>已经提交的作业数量</span>
                </template>
                <a-icon type="question-circle" style="color: gray" />
              </a-tooltip>
            </div>
            <div class="data_number">{{ report.myAdditionWorkCount }}</div>
          </div>
          <div class="data_box">
            <div class="data_text">
              待完成作业数量
              <a-tooltip placement="top">
                <template slot="title">
                  <span>待完成的作业的数量</span>
                </template>
                <a-icon type="question-circle" style="color: gray" />
              </a-tooltip>
            </div>
            <div class="data_number">{{ report.todoAdditionWorkCount }}</div>
          </div>
          <div class="data_box">
            <div class="data_text">
              已完成课件数
              <a-tooltip placement="top">
                <template slot="title">
                  <span>教师批改作业的份数</span>
                </template>
                <a-icon type="question-circle" style="color: gray" />
              </a-tooltip>
            </div>
            <div class="data_number">{{ report.courseMediaCount }}</div>
          </div>
          <div class="data_box">
            <div class="data_text">
              学习时长
              <a-tooltip placement="top">
                <template slot="title">
                  <span>观看课程视频的时长</span>
                </template>
                <a-icon type="question-circle" style="color: gray" />
              </a-tooltip>
            </div>
            <div class="data_number">{{ report.videoStudyDuration }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="home_bottom" v-if="userIdentity == 1">
      <div class="box_header">
        <span>我的班级</span>
        <router-link to="studentMyclass">查看更多>></router-link>
      </div>
      <div class="box_content classBox" style="overflow-y: auto;">
        <div class="box_list" v-show="classList.length > 0" v-for="(item, index) in classList" :key="index" @click="$router.push({
          path: 'classDetails',
          query: {
            id: item.id,
          },
        })">
          <img :src="item.departCover_url" alt="" />
          <p class="box_text box_text1" style="">{{ item.departName }}</p>
        </div>
        <p v-if="classList.length == 0" class="listTips">暂无数据</p>
      </div>
    </div>
    <!-- <div class="home_bottom" v-if="userIdentity == 1">
      <div class="box_header">
        <span>课程作品</span>
      </div>
      <div class="box_content classBox">
        <div class="box_list" v-show="workList.length > 0" v-for="(item, index) in workList" :key="index"
          @click="toDetail(item.id)">
          <img :src="item.courseCover_url" alt="" />
          <p class="box_text box_text1" style="">{{ item.courseDesc }}</p>
        </div>
        <p v-if="workList.length == 0" class="listTips">暂无数据</p>
      </div>
    </div> -->
    <a-modal width="60%" v-model="modelStatus" title="编辑工具" :footer="null" @ok="modelStatus = false">
      <ul class="toolBox">
        <li class="toolList">
          <img src="../../assets/Jrcode.png" alt="" />
          <p style="font-weight: bold">Jrcode</p>
          <p>编程启蒙入门的首选</p>
          <a-button type="primary" @click="toEditor(3)" style="
              background-color: #67c23a;
              border-color: #67c23a;
              margin-top: 15px;
            ">Let's code</a-button>
        </li>
        <li class="toolList">
          <img src="../../assets/Scratch.png" alt="" />
          <p style="font-weight: bold">Scratch</p>
          <p>最火爆的图形化语言</p>
          <a-button type="primary" @click="toEditor(2)" style="
              background-color: #e6a23c;
              border-color: #e6a23c;
              margin-top: 15px;
            ">Let's code</a-button>
        </li>
        <li class="toolList">
          <img src="../../assets/Python.png" alt="" />
          <p style="font-weight: bold">Python</p>
          <p>源代码编程进阶挑战</p>
          <a-button type="primary" @click="toEditor(5)" style="
              background-color: rgb(128, 123, 224);
              border-color: rgb(128, 123, 224);
              margin-top: 15px;
            ">Let's code</a-button>
        </li>
        <li class="toolList">
          <img src="../../assets/Cccc.png" alt="" />
          <p style="font-weight: bold">C/C++</p>
          <p>信息学奥赛必备语言</p>
          <a-button type="primary" @click="toEditor(7)" style="
              background-color: rgb(2, 128, 206);
              border-color: rgb(2, 128, 206);
              margin-top: 15px;
            ">Let's code</a-button>
        </li>
      </ul>
    </a-modal>
  </div>
</template>
<script>
import { getAction } from "@/api/manage";
import classbox from "./components/classBox";
export default {
  name: "classRoomHome",
  components: { classbox },
  data() {
    return {
      courseList: [],
      modelStatus: false,
      report: {},
      workList: [],
      classList: []
    };
  },
  computed: {
    userIdentity() {
      return this.$store.state.user.info.userIdentity;
    },
  },
  watch: {},
  methods: {
    goPage(url) {
      this.$router.push({ path: url });
    },
    init() {
      getAction("/teaching/teachingCourse/getNewCourse", {
        dayRange: 100,
        limit: 1,
      }).then((res) => {
        if (res.success) {
          this.courseList = res.result;
        }
      });

    },
    studentInit() {
      getAction("/teaching/teachingDepartDayLog/studentReport").then((res) => {
        if (res.success) {
          this.report = res.result;
        } else {
          this.$message.info(res.message);
        }
      });
      getAction('sys/sysDepart/mineClassroom').then(res => {
        console.log(res, '我的班级')
        if (res.success) {
          this.classList = res.result
        }
      })
      // getAction("/teaching/teachingWork/mineWorkList", {
      //   courseType: "",
      //   pageSize: 999,
      //   scene: "course",
      // }).then((res) => {
      //   if (res.code == 200) {
      //     this.workList = res.result.records;
      //   }
      // });
    },
    teachInit() {

    },
    toDetail(id) {
      this.$router.push({
        path: 'courseDetail',
        query: {
          id: id,
        },
      })
    },
    toEditor(type) {
      let url = "#";
      switch (type) {
        case 2:
          url = "/scratch3/index.html?scene=create";
          break;
        case 3:
          url = "/scratchjr/home.html";
          break;
        case 5:
          url = "/onlinecode/index.html?lang=python";
          break;
        case 7:
          url = "/onlinecode/index.html?lang=cpp";
          break;
        default:
          url = "/scratch3/index.html?scene=create";
      }
      window.open(url);
    },
  },
  created() {
    this.init();
    if (this.userIdentity == 1) {
      this.studentInit();
    } else {

    }
  },
  mounted() { },
};
</script>
<style lang='scss' scoped>
#classRoomHome {
  width: 100%;
  height: 100%;

  .box_content {
    width: 100%;
    height: calc(100% - 50px);
    overflow-y: auto;

    .courseList {
      padding: 0 20px;
    }

    .entrance_box {
      width: 70px;
      height: 100px;
      cursor: pointer;

      img {
        width: 70px !important;
        height: 70px !important;
        border-radius: 50%;
      }

      .entrance_tips {
        width: 100%;
        height: 30px;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        color: #333;
      }
    }
  }

  .home_top {
    width: 100%;
    height: 40%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .home_left {
      width: 50%;
      height: 100%;
      background: #fff;
      border-radius: 5px;
    }

    .home_right {
      width: calc(30% - 8px);
      height: 100%;
      background: #fff;
      border-radius: 5px;

      .data_box {
        width: 45%;
        height: 80px;
        border: 1px solid #ccc;
        border-radius: 4px;

        .data_text {
          width: 100%;
          height: 40px;
          text-align: center;
          line-height: 50px;
          font-size: 16px;
        }

        .data_number {
          width: 100%;
          height: 40px;
          text-align: center;
          line-height: 30px;
          font-size: 18px;
          color: #333;
          font-weight: bold;
        }
      }
    }
  }

  .home_bottom {
    width: 100%;
    height: calc(60% - 8px);
    margin-top: 8px;
    background: #fff;
    border-radius: 5px;
  }
}

.toolBox {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .toolList {
    width: 150px;
    height: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 14px;
    color: #333;

    img {
      width: 150px;
      height: 150px;
    }
  }
}
</style>